import { ChevronDownIcon } from "@chakra-ui/icons";
import { Box, Collapse, Heading } from "@chakra-ui/react";
import { useState } from "react";
import { ConditionRules } from "./ConditionRules";
import RuleBranch from "./RulesItemsComp/RuleBranch";
const RuleTypeComp = ({ control, register, path, rule, schema, depth }) => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prev) => !prev);
  return (
    <Box mt={4} borderLeft="3px solid" borderColor="blue.100" pl={3}>
      {/* <Button
        size="xs"
        onClick={toggle}
        rightIcon={open ? <ChevronUpIcon /> : <ChevronDownIcon />}
      >
        Condition
      </Button> */}
      <Box
        as="button"
        width="100%"
        px={4}
        py={3}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        fontWeight="semibold"
        borderRadius="md"
        bg="#F7FAFC"
        _hover={{ bg: "gray.100" }}
        onClick={toggle}
      >
        <Box textAlign="left">
          {" "}
          <Heading size="xs">Condition</Heading>
        </Box>

        <Box
          transform={open ? "rotate(180deg)" : "rotate(0deg)"}
          transition="transform 0.2s ease"
        >
          <ChevronDownIcon />
        </Box>
      </Box>

      <Collapse in={open} animateOpacity>
        <Box mt={2}>
          <ConditionRules
            control={control}
            register={register}
            path={`${path}.CONDITION`}
            groupData={
              rule.CONDITION ?? {
                Field: "",
                Operator: "==",
                Value: "",
                ValueType: "",
              }
            }
            fieldKey={rule.ID}
            sectionKey="RULES"
            mainSchemaData={schema}
          />
        </Box>
      </Collapse>
      <>
        {/* Branches */}
        <RuleBranch
          label="TRUE_STEP"
          color="green"
          control={control}
          register={register}
          schema={schema}
          path={`${path}.TRUE_STEP`}
          depth={depth}
        />

        <RuleBranch
          label="FALSE_STEP"
          color="red"
          control={control}
          register={register}
          schema={schema}
          path={`${path}.FALSE_STEP`}
          depth={depth}
        />
      </>
    </Box>
  );
};

export default RuleTypeComp;
